import { Theme } from '@material-ui/core';

export const muiFormHelperTextOverrides = (theme: Theme): Theme['overrides'] => ({
  MuiFormHelperText: {
    root: {
      fontSize: '12px',
      color: theme.palette.text.secondary,
      opacity: 0.6,
      marginLeft: theme.spacing(1.75),
    },
  },
});
